import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { useQueryClient } from "@tanstack/react-query";
import { displayNotify } from "../../../../../shared/services/Notifications/NotificationServices";

export default function useDeleteSide(guID?: string) {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (side_id?: string) => axios.delete(`/events/${guID}/parties/${side_id}/`),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['events', guID] });
            displayNotify({
                status: 'success',
                title: 'Изменения сохранены',
                description: 'Сторона удалена'
            })
        }
    })
}